<template>
<div style="display: flex; justify-content: center;" class="counter_box">
    <div class="flip-counter">
    <template v-for="(digit, index) in digitGroups">
      <!-- 数字组 -->
      <div class="digit-group">
        <div class="flip-digit" v-for="(d, i) in digit" :key="i"
          :class="{ 'flipping': isFlipping && shouldFlip(getAbsoluteIndex(index, i)) }">
          <div class="w_number_box">
            <div class="flip-card_t"
              :class="{ 'flip-animate-top': isFlipping && shouldFlip(getAbsoluteIndex(index, i)) }"></div>
            <div class="w_box"></div>
            <div class="flip-card_b"
              :class="{ 'flip-animate-bottom': isFlipping && shouldFlip(getAbsoluteIndex(index, i)) }"></div>
            <div class="w_number_box_txt">{{ d }}</div>
          </div>
        </div>
        <span class="comma-separator" v-if="index < digitGroups.length - 1">,</span>
      </div>
    </template>
  </div>
</div>
</template>

<script>
export default {
  name: 'FlipCounter',
  props: {
    number: {
      type: Number,
      required: true,
      default: 0
    },
    duration: {
      type: Number,
      default: 600
    }
  },
  data() {
    return {
      displayedNumber: this.padNumber(this.number).split(''),
      nextDigits: this.padNumber(this.number).split(''),
      isFlipping: false,
      flippingIndexes: []
    };
  },
  computed: {
    digitGroups() {
      // 将数字分成3位一组
      const digits = this.displayedNumber.join('');
      const groups = [];
      for (let i = 0; i < digits.length; i += 3) {
        groups.push(digits.substr(i, 3).split(''));
      }
      return groups;
    }
  },
  methods: {
    padNumber(num) {
      // 补零到6位
      return String(num).padStart(6, '0');
    },
    getAbsoluteIndex(groupIndex, digitIndex) {
      // 计算在完整数字中的绝对位置
      return groupIndex * 3 + digitIndex;
    },
    shouldFlip(index) {
      return this.flippingIndexes.includes(index);
    },
    getChangedDigits(oldStr, newStr) {
      const changedIndexes = [];
      const maxLength = Math.max(oldStr.length, newStr.length);

      for (let i = 0; i < maxLength; i++) {
        if (oldStr[i] !== newStr[i]) {
          changedIndexes.push(i);
        }
      }

      return changedIndexes;
    }
  },
  watch: {
    number(newVal) {
      const newNumberStr = this.padNumber(newVal);
      const currentNumberStr = this.displayedNumber.join('');

      if (newNumberStr !== currentNumberStr) {
        this.flippingIndexes = this.getChangedDigits(currentNumberStr, newNumberStr);
        this.nextDigits = newNumberStr.split('');
        this.isFlipping = true;

        setTimeout(() => {
          this.displayedNumber = this.nextDigits;
          this.isFlipping = false;
          this.flippingIndexes = [];
        }, this.duration);
      }
    }
  }
};
</script>

<style scoped>
.counter_box{
  margin-top: 40px;
}
/* 原有样式保持不变 */
.w_box {
  width: 56px;
  height: 4px;
}

.flip-counter {
  display: flex;
  font-family: 'Arial', sans-serif;
  /* padding: 20px; */
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  align-items: center;
}

.flip-digit {
  margin: 0 5px;
  perspective: 200px;
  position: relative;
}

.w_number_box {
  position: relative;
  width: 56px;
  height: 80px;
  line-height: 75px;
  text-align: center;
}

.flip-card_t {
  top: 0;
  left: 0;
  position: absolute;
  width: 56px;
  height: 38px;
  background: rgba(0, 168, 255, 0.7);
  border-radius: 4px;
  transform-origin: bottom;
  transition: transform 0.3s ease-out;
}

.flip-card_b {
  bottom: 0;
  left: 0;
  position: absolute;
  width: 56px;
  height: 38px;
  background: rgba(0, 168, 255, 0.7);
  border-radius: 4px;
  transform-origin: top;
  transition: transform 0.3s ease-out;
}

.w_number_box_txt {
  position: relative;
  z-index: 99;
  font-weight: 600;
  font-size: 50px;
  color: #FFFFFF;
}

/* 新增的组和逗号样式 */
.digit-group {
  display: flex;
  align-items: center;
  margin-right: 5px;
}

.comma-separator {
  font-size: 50px;
  color: #FFFFFF;
  margin: 0 5px;
  align-self: flex-end;
  padding-bottom: 15px;
}

/* 翻牌动画 */
.flip-animate-top {
  animation: flipTop 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.flip-animate-bottom {
  animation: flipBottom 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes flipTop {
  0% {
    transform: rotateX(0deg);
    z-index: 1;
  }

  50% {
    transform: rotateX(-90deg);
    z-index: 1;
  }

  51% {
    z-index: 0;
  }

  100% {
    transform: rotateX(0deg);
    z-index: 0;
  }
}

@keyframes flipBottom {
  0% {
    transform: rotateX(0deg);
    z-index: 0;
  }

  50% {
    transform: rotateX(90deg);
    z-index: 0;
  }

  51% {
    z-index: 1;
  }

  100% {
    transform: rotateX(0deg);
    z-index: 1;
  }
}
</style>